var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"long-press",rawName:"v-long-press",value:(150),expression:"150"}],ref:"longTap",on:{"long-press-start":_vm.onLongPressStart,"long-press-stop":_vm.onLongPressStop}},[_vm._v(" 测试长按事件 ")])}
var staticRenderFns = []

export { render, staticRenderFns }